
      import "../src/index.ts";

      const fmt = (l) =>
        "[" + l.map((n) => n.toFixed(1)).join(", ") + "]";

      const ide = document.getElementById("ide");
      const ideInner = document.getElementById("ide-inner");
      const sidebar = ide.querySelector("schism-pane");
      const ideOuterLive = document.getElementById("ide-outer-live");
      const ideInnerLive = document.getElementById("ide-inner-live");
      document.getElementById("ide-collapse").onclick = () => sidebar.collapse();
      document.getElementById("ide-expand").onclick = () => sidebar.expand();
      document.getElementById("ide-reset").onclick = () => {
        ide.setLayout([22, 56, 22]);
        ideInner.setLayout([70, 30]);
      };
      ide.addEventListener("layout-change", (e) => {
        ideOuterLive.textContent = fmt(e.detail.layout);
      });
      ideInner.addEventListener("layout-change", (e) => {
        ideInnerLive.textContent = fmt(e.detail.layout);
      });

      const ctl = document.getElementById("ctl");
      window.ctl = ctl;
      const ctlLive = document.getElementById("ctl-live");
      ctl.addEventListener("layout-change", (e) => {
        ctlLive.textContent = fmt(e.detail.layout);
      });
      const ctlDuration = document.getElementById("ctl-duration");
      const ctlEasing = document.getElementById("ctl-easing");
      ctlDuration.addEventListener("change", () => {
        ctl.style.setProperty("--schism-animate-duration", ctlDuration.value);
      });
      ctlEasing.addEventListener("change", () => {
        ctl.style.setProperty("--schism-animate-easing", ctlEasing.value);
      });
    